import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=2dbfd8a6&"
import script from "./Blocks.vue?vue&type=script&lang=js&"
export * from "./Blocks.vue?vue&type=script&lang=js&"
import style0 from "./Blocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports